import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7999f8cc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7999f8cc')) {
      api.createRecord('7999f8cc', component.options)
    } else {
      api.reload('7999f8cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7999f8cc", function () {
      api.rerender('7999f8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/pagos/index.vue"
export default component.exports